const SaleOrderDetail: React.FC = () => {
  return (
    <>
      <div className='row justify-content-center my-20'>
        <div className='col-xl-8 col-lg-8 col-md-12'>
          <div className='card flex-row-fluid '>
            <div className='card-header'>
              <div className='card-title'>
                <h3>Order Details</h3>
              </div>
            </div>
            <div className='card-body'>
              <div className='row'>
                <div className='col-xl-3 col-lg-3 col-md-3 col-sm-12'>
                  <h5>Recipient Information</h5>
                  <div className='line-h-10'>
                    <p className=''>Pratik Johnson</p>
                    <p className=''>1234 Dummy Sreet, </p>
                    <p className=''>Shanti appartment, Bhayandar,</p>
                    <p className=''>Mumbai, Maharashtra, India - 552452 </p>
                  </div>
                </div>
                <div className='col-xl-3 col-lg-3 col-md-3 col-sm-12'>
                  <h5>Product Detail</h5>
                  <div className='line-h-10 mb-5'>
                    <p className='mb-0'>Pratik Johnson</p>
                  </div>

                  <h5>Product Detail</h5>
                  <div className='line-h-10 mb-5'>
                    <p className='mb-0'>Pratik Johnson</p>
                  </div>
                </div>

                <div className='col-xl-3 col-lg-3 col-md-3 col-sm-12'>
                  <h5>Product Detail</h5>
                  <div className='line-h-10 mb-5'>
                    <p className='mb-0'>Pratik Johnson</p>
                  </div>

                  <h5>Product Detail</h5>
                  <div className='line-h-10 mb-5'>
                    <p className='mb-0'>Pratik Johnson</p>
                  </div>
                </div>

                <div className='col-xl-3 col-lg-3 col-md-3 col-sm-12'>
                  <h5>Product Detail</h5>
                  <div className='line-h-10 mb-5'>
                    <p className='mb-0'>Pratik Johnson</p>
                  </div>

                  <h5>Product Detail</h5>
                  <div className='line-h-10 mb-5'>
                    <p className='mb-0'>Pratik Johnson</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='card mt-10'>
            <div className='card-header'>
              <div className='card-title'>
                <h3>Work Order</h3>
              </div>
            </div>

            <div className='card-body'>
              <div className='accordion' id='product-tracker'>
                <div className='accordion-item'>
                  <h2 className='accordion-header'>
                    <button
                      className='accordion-button fs-4 fw-semibold text-dark'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#product1'
                      aria-expanded='true'
                      aria-controls='product1'
                    >
                      Round Imitation/Artificial jewellery - Pendant Necklace
                    </button>
                  </h2>
                  <div
                    id='product1'
                    className='accordion-collapse collapse show'
                    data-bs-parent='#product-tracker'
                  >
                    <div className='accordion-body'>
                      <div className='row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5'>
                        <div className='col mb-4'>
                          <h3 className='fs-5 fw-semibold mb-0 ms-4 mb-2'>Casting</h3>
                          <div className='py-2 px-4 border'>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Completed</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>In Progress</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                100
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Pending</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className='col mb-4'>
                          <h3 className='fs-5 fw-semibold mb-0 ms-4 mb-2'>Polishing</h3>
                          <div className='py-2 px-4 border'>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Completed</p>
                              {/* <span className="badge py-3 px-4 fs-8 badge-light-success">Complated</span>                   */}
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>In Progress</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                100
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Pending</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className='col mb-4'>
                          <h3 className='fs-5 fw-semibold mb-0 ms-4 mb-2'>Motti Fitting</h3>
                          <div className='py-2 px-4 border'>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Completed</p>
                              {/* <span className="badge py-3 px-4 fs-8 badge-light-success">Complated</span>                   */}
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>In Progress</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                100
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Pending</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className='col mb-4'>
                          <h3 className='fs-5 fw-semibold mb-0 ms-4 mb-2'>Pasting</h3>
                          <div className='py-2 px-4 border'>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Completed</p>
                              {/* <span className="badge py-3 px-4 fs-8 badge-light-success">Complated</span>                   */}
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>In Progress</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                100
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Pending</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className='col mb-4'>
                          <h3 className='fs-5 fw-semibold mb-0 ms-4 mb-2'>Packing</h3>
                          <div className='py-2 px-4 border'>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Completed</p>
                              {/* <span className="badge py-3 px-4 fs-8 badge-light-success">Complated</span>                   */}
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>In Progress</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                100
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Pending</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='accordion-item'>
                  <h2 className='accordion-header'>
                    <button
                      className='accordion-button fs-4 fw-semibold collapsed  text-dark'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#product2'
                      aria-expanded='false'
                      aria-controls='product2'
                    >
                      Heart Imitation/Artificial jewellery - Pendant Necklace
                    </button>
                  </h2>
                  <div
                    id='product2'
                    className='accordion-collapse collapse'
                    data-bs-parent='#product-tracker'
                  >
                    <div className='accordion-body'>
                      <div className='row row-cols-sm-2 row-cols-md-5 '>
                        <div className='col mb-4'>
                          <h3 className='fs-5 fw-semibold mb-0 ms-4 mb-2'>Casting</h3>
                          <div className='py-2 px-4 border'>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Completed</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>In Progress</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                100
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Pending</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className='col mb-4'>
                          <h3 className='fs-5 fw-semibold mb-0 ms-4 mb-2'>Polishing</h3>
                          <div className='py-2 px-4 border'>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Completed</p>
                              {/* <span className="badge py-3 px-4 fs-8 badge-light-success">Complated</span>                   */}
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>In Progress</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                100
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Pending</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className='col mb-4'>
                          <h3 className='fs-5 fw-semibold mb-0 ms-4 mb-2'>Motti Fitting</h3>
                          <div className='py-2 px-4 border'>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Completed</p>
                              {/* <span className="badge py-3 px-4 fs-8 badge-light-success">Complated</span>                   */}
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>In Progress</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                100
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Pending</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className='col mb-4'>
                          <h3 className='fs-5 fw-semibold mb-0 ms-4 mb-2'>Pasting</h3>
                          <div className='py-2 px-4 border'>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Completed</p>
                              {/* <span className="badge py-3 px-4 fs-8 badge-light-success">Complated</span>                   */}
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>In Progress</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                100
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Pending</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className='col mb-4'>
                          <h3 className='fs-5 fw-semibold mb-0 ms-4 mb-2'>Packing</h3>
                          <div className='py-2 px-4 border'>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Completed</p>
                              {/* <span className="badge py-3 px-4 fs-8 badge-light-success">Complated</span>                   */}
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>In Progress</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                100
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Pending</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='accordion-item'>
                  <h2 className='accordion-header'>
                    <button
                      className='accordion-button fs-4 fw-semibold collapsed text-dark'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#product3'
                      aria-expanded='false'
                      aria-controls='product2'
                    >
                      Stainless Steel Imitation Jewelry Butterfly Heart
                    </button>
                  </h2>
                  <div
                    id='product3'
                    className='accordion-collapse collapse'
                    data-bs-parent='#product-tracker'
                  >
                    <div className='accordion-body'>
                      <div className='row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5'>
                        <div className='col mb-4'>
                          <h3 className='fs-5 fw-semibold mb-0 ms-4 mb-2'>Casting</h3>
                          <div className='py-2 px-4 border'>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Completed</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>In Progress</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                100
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Pending</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className='col mb-4'>
                          <h3 className='fs-5 fw-semibold mb-0 ms-4 mb-2'>Polishing</h3>
                          <div className='py-2 px-4 border'>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Completed</p>
                              {/* <span className="badge py-3 px-4 fs-8 badge-light-success">Complated</span>                   */}
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>In Progress</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                100
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Pending</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className='col mb-4'>
                          <h3 className='fs-5 fw-semibold mb-0 ms-4 mb-2'>Motti Fitting</h3>
                          <div className='py-2 px-4 border'>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Completed</p>
                              {/* <span className="badge py-3 px-4 fs-8 badge-light-success">Complated</span>                   */}
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>In Progress</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                100
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Pending</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className='col mb-4'>
                          <h3 className='fs-5 fw-semibold mb-0 ms-4 mb-2'>Pasting</h3>
                          <div className='py-2 px-4 border'>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Completed</p>
                              {/* <span className="badge py-3 px-4 fs-8 badge-light-success">Complated</span>                   */}
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>In Progress</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                100
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Pending</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className='col mb-4'>
                          <h3 className='fs-5 fw-semibold mb-0 ms-4 mb-2'>Packing</h3>
                          <div className='py-2 px-4 border'>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Completed</p>
                              {/* <span className="badge py-3 px-4 fs-8 badge-light-success">Complated</span>                   */}
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>In Progress</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                100
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Pending</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='accordion-item'>
                  <h2 className='accordion-header'>
                    <button
                      className='accordion-button fs-4 fw-semibold collapsed text-dark'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#product4'
                      aria-expanded='false'
                      aria-controls='product2'
                    >
                      Heart Imitation/Artificial jewellery - Pendant Necklace
                    </button>
                  </h2>
                  <div
                    id='product4'
                    className='accordion-collapse collapse'
                    data-bs-parent='#product-tracker'
                  >
                    <div className='accordion-body'>
                      <div className='row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5'>
                        <div className='col mb-4'>
                          <h3 className='fs-5 fw-semibold mb-0 ms-4 mb-2'>Casting</h3>
                          <div className='py-2 px-4 border'>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Completed</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>In Progress</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                100
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Pending</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className='col mb-4'>
                          <h3 className='fs-5 fw-semibold mb-0 ms-4 mb-2'>Polishing</h3>
                          <div className='py-2 px-4 border'>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Completed</p>
                              {/* <span className="badge py-3 px-4 fs-8 badge-light-success">Complated</span>                   */}
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>In Progress</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                100
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Pending</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className='col mb-4'>
                          <h3 className='fs-5 fw-semibold mb-0 ms-4 mb-2'>Motti Fitting</h3>
                          <div className='py-2 px-4 border'>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Completed</p>
                              {/* <span className="badge py-3 px-4 fs-8 badge-light-success">Complated</span>                   */}
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>In Progress</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                100
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Pending</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className='col mb-4'>
                          <h3 className='fs-5 fw-semibold mb-0 ms-4 mb-2'>Pasting</h3>
                          <div className='py-2 px-4 border'>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Completed</p>
                              {/* <span className="badge py-3 px-4 fs-8 badge-light-success">Complated</span>                   */}
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>In Progress</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                100
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Pending</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className='col mb-4'>
                          <h3 className='fs-5 fw-semibold mb-0 ms-4 mb-2'>Packing</h3>
                          <div className='py-2 px-4 border'>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Completed</p>
                              {/* <span className="badge py-3 px-4 fs-8 badge-light-success">Complated</span>                   */}
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>In Progress</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                100
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Pending</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='accordion-item'>
                  <h2 className='accordion-header'>
                    <button
                      className='accordion-button fs-4 fw-semibold collapsed text-dark'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#product5'
                      aria-expanded='false'
                      aria-controls='product2'
                    >
                      Stainless Steel Imitation Jewelry Butterfly Heart
                    </button>
                  </h2>
                  <div
                    id='product5'
                    className='accordion-collapse collapse'
                    data-bs-parent='#product-tracker'
                  >
                    <div className='accordion-body'>
                      <div className='row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5'>
                        <div className='col mb-4'>
                          <h3 className='fs-5 fw-semibold mb-0 ms-4 mb-2'>Casting</h3>
                          <div className='py-2 px-4 border'>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Completed</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>In Progress</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                100
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Pending</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className='col mb-4'>
                          <h3 className='fs-5 fw-semibold mb-0 ms-4 mb-2'>Polishing</h3>
                          <div className='py-2 px-4 border'>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Completed</p>
                              {/* <span className="badge py-3 px-4 fs-8 badge-light-success">Complated</span>                   */}
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>In Progress</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                100
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Pending</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className='col mb-4'>
                          <h3 className='fs-5 fw-semibold mb-0 ms-4 mb-2'>Motti Fitting</h3>
                          <div className='py-2 px-4 border'>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Completed</p>
                              {/* <span className="badge py-3 px-4 fs-8 badge-light-success">Complated</span>                   */}
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>In Progress</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                100
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Pending</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className='col mb-4'>
                          <h3 className='fs-5 fw-semibold mb-0 ms-4 mb-2'>Pasting</h3>
                          <div className='py-2 px-4 border'>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Completed</p>
                              {/* <span className="badge py-3 px-4 fs-8 badge-light-success">Complated</span>                   */}
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>In Progress</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                100
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Pending</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className='col mb-4'>
                          <h3 className='fs-5 fw-semibold mb-0 ms-4 mb-2'>Packing</h3>
                          <div className='py-2 px-4 border'>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Completed</p>
                              {/* <span className="badge py-3 px-4 fs-8 badge-light-success">Complated</span>                   */}
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>In Progress</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                100
                              </button>
                            </div>
                            <div className='d-flex flex-stack py-2'>
                              <p className='fw-semibold mb-1'>Pending</p>
                              <button
                                type='button'
                                className='btn btn-icon btn-sm h-auto btn-color-gray-500 btn-active-color-primary justify-content-end'
                              >
                                50
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='card mt-10'>
            <div className='card-header'>
              <div className='card-title'>
                <h3>Sales Order</h3>
              </div>
            </div>

            <div className='card-body'>
              <div className='row'>
                <div className='d-flex justify-content-between flex-colomn-1200'>
                  <div className='order-tracking completed'>
                    <span className='is-complete'></span>
                    <p className='main-status-label'>
                      Order Created
                      <br />
                      <span>Mon, June 24</span>
                    </p>
                  </div>

                  <div className='order-tracking completed'>
                    <span className='is-complete'></span>
                    <p className='main-status-label'>
                      Partially Packed
                      <br />
                      <span>Mon, June 24</span>
                    </p>
                    <div className='hoverd-details'>
                      <ul className='tracker-sublist'>
                        <li>
                          <div className='tracker-more-details'>
                            <p className='naration strong mt-0 mb-0'>Partially Packed</p>
                            <p className='mt-0'>Thu, 14 Sep 24, 10:55</p>
                          </div>
                        </li>
                        <li>
                          <div className='tracker-more-details'>
                            <p className='naration strong mt-0 mb-0'>Partially Packed</p>
                            <p className='mt-0'>Thu, 16 Sep 24, 10:55</p>
                          </div>
                        </li>
                        <li>
                          <div className='tracker-more-details'>
                            <p className='naration strong mt-0 mb-0'>Fully Packed</p>
                            <p className='mt-0'>Thu, 22 Sep 24, 10:55</p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className='order-tracking completed'>
                    <span className='is-complete'></span>
                    <p>
                      Fully Packed
                      <br />
                      <span>Tue, June 25</span>
                    </p>
                  </div>

                  <div className='order-tracking completed'>
                    <span className='is-complete'></span>
                    <p>
                      Partially Shipped
                      <br />
                      <span>Fri, June 28</span>
                    </p>
                  </div>

                  <div className='order-tracking'>
                    <span className='is-complete'></span>
                    <p>
                      Fully Shipped
                      <br />
                      <span>Fri, June 28</span>
                    </p>
                  </div>

                  <div className='order-tracking'>
                    <span className='is-complete'></span>
                    <p>
                      Partially Delivered
                      <br />
                      <span>Fri, June 28</span>
                    </p>
                  </div>

                  <div className='order-tracking'>
                    <span className='is-complete'></span>
                    <p>
                      Fully Delivered
                      <br />
                      <span>Fri, June 28</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="card-body">

                                <div className="sales-order-tracker">
                                    <div id="timeline-content">
                                        <ul className="timeline">
                                            <li className="event" data-date="65Million B.C.">
                                            <h3>Fully Packed</h3>
                                                <p>22 Sep 2024 - <small>14:30</small></p> 
                                                <ul className="tracker-sublist">
                                                    <li>
                                                        <div className="tracker-more-details">
                                                            <p className="strong mb-0">Thu, 14 Sep 24, 10:55</p>
                                                            <p className="naration">Partially Packed</p>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="tracker-more-details">
                                                            <p className="strong mb-0">Thu, 16 Sep 24, 10:55</p>
                                                            <p className="naration">Partially Packed</p>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="tracker-more-details">
                                                            <p className="strong mb-0">Thu, 22 Sep 24, 10:55</p>
                                                            <p className="naration">Fully Packed</p>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li className="event" data-date="65Million B.C.">
                                            <h3>Partially Shipped</h3>
                                                <p>22 Sep 2024 - <small>14:30</small></p> 
                                                <ul className="tracker-sublist">
                                                    <li>
                                                        <div className="tracker-more-details">
                                                            <p className="strong mb-0">Thu, 14 Sep 24, 10:55</p>
                                                            <p className="naration">Partially Shipped</p>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="tracker-more-details">
                                                            <p className="strong mb-0">Thu, 22 Sep 24, 14:30</p>
                                                            <p className="naration">Partially Shipped</p>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li className="event" data-date="65Million B.C.">
                                            <h3>Partially Deliverd</h3>
                                                <p>24 Sep 2024 - <small>14:30</small></p> 
                                                <ul className="tracker-sublist">
                                                    <li>
                                                        <div className="tracker-more-details">
                                                            <p className="strong mb-0">Thu, 24 Sep 24, 14:30</p>
                                                            <p className="naration">Partially Deliverd</p>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </li>

                                             <li className="event" data-date="65Million B.C.">
                                            <h3>Partially Packed</h3>
                                                <p>22 Sep 2024 - <small>14:30</small></p> 
                                                <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure nisi non corporis possimus explicabo temporibus recusandae minima laborum dolorem, illum nam exercitationem quae minus sed sapiente asperiores nobis impedit harum!</p>
                                            </li> 
                                        </ul>
                                    </div>
                                    </div>
                            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};
export default SaleOrderDetail;
